import type { PresetUsage } from '../../gql';

import { mockPresetPlacement } from './mockPresetPlacement';
import { mockUsage } from './mockUsage';

const mockPresetUsage = (overwrite?: Partial<PresetUsage>): PresetUsage => ({
    usage: mockUsage(),
    presetPlacements: [[mockPresetPlacement()]],
    ...overwrite,
});

export { mockPresetUsage };
